import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AppConfigProvider } from "../shared/useAppConfig";
import { PatientModeProvider } from "../PatientMode/usePatientMode";
import AppErrorBoundary from "./AppErrorBoundary";
import { BlueprintProvider } from '@blueprintjs/core';
import AuthContainer from './AuthContainer';
import LazyLoad from '../shared/LazyLoad';
import { publicRoutes } from "../../routePaths";


const publicFormsLoader = () => import(/* webpackChunkName: "lzPublicForms" */ "../publicForms/PublicFormsBaseRoute");
const LazyPublicForms: React.FC = () => <LazyLoad componentLoader={publicFormsLoader} />;

const App: React.FC = () => {
  return (
    <div className="app">
      <AppErrorBoundary>
        <AppConfigProvider>
          <PatientModeProvider>
            <BlueprintProvider>
              <BrowserRouter>
                {/* Public/anonymous form links must never hit the sensei-authentication
                    login gate, so they're routed here, above AuthContainer. */}
                <Switch>
                  <Route path={publicRoutes.forms.base} component={LazyPublicForms} />
                  <Route component={AuthContainer} />
                </Switch>
              </BrowserRouter>
            </BlueprintProvider>
          </PatientModeProvider>
        </AppConfigProvider>
      </AppErrorBoundary>
    </div>
  );
}


export default App;
